import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { handlesGroup as i } from "../../../core/handleUtils.js";
import { IntersectionSnappingHint as n } from "./hints/IntersectionSnappingHint.js";
import { LineSnappingHint as t } from "./hints/LineSnappingHint.js";
import { ParallelSnappingHint as s } from "./hints/ParallelSnappingHint.js";
import { PointSnappingHint as o } from "./hints/PointSnappingHint.js";
import { RightAngleSnappingHint as e } from "./hints/RightAngleSnappingHint.js";

var r = /*#__PURE__*/function () {
  function r() {
    _classCallCheck(this, r);
  }

  _createClass(r, [{
    key: "draw",
    value: function draw(_r, a) {
      var p = this.getUniqueHints(_r),
          h = [];

      var _iterator = _createForOfIteratorHelper(p),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _i = _step.value;
          _i instanceof n && h.push(this.visualizeIntersectionPoint(_i, a)), _i instanceof t && h.push(this.visualizeLine(_i, a)), _i instanceof s && h.push(this.visualizeParallelSign(_i, a)), _i instanceof e && h.push(this.visualizeRightAngleQuad(_i, a)), _i instanceof o && h.push(this.visualizePoint(_i, a));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return i(h);
    }
  }, {
    key: "getUniqueHints",
    value: function getUniqueHints(i) {
      var n = [];

      var _iterator2 = _createForOfIteratorHelper(i),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _t = _step2.value;

          var _i2 = !0;

          var _iterator3 = _createForOfIteratorHelper(n),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _s = _step3.value;

              if (_t.equals(_s)) {
                _i2 = !1;
                break;
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          _i2 && n.push(_t);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return n;
    }
  }]);

  return r;
}();

export { r as SnappingVisualizer };